export const services = [
  {
    slug: "obstetric-care",
    title: "Obstetric Care",
    short: "Complete pregnancy care from conception to delivery, ensuring health and safety of both mother and baby.",
    icon: "Baby",
    image: "/images/facilities/DSC04312.webp",
    bullets: ["Prenatal consultations", "High-risk pregnancy care", "Delivery support & guidance"],
    long: [
      "From the very first heartbeat to the day you hold your baby in your arms, Dr. Priyanka Gupta walks beside you with calm expertise and warmth. Comprehensive antenatal care is built around regular monitoring, evidence-based protocols and lifestyle guidance tailored to you.",
      "With over 20,000 deliveries across Delhi, Vadodara, Bengaluru and Gurugram, the obstetric program emphasises safe, modern birthing — including support for normal delivery, painless labour, and C-section when medically indicated.",
    ],
    highlights: [
      "First-trimester screening & dating scans",
      "Trimester-wise nutrition & wellness plans",
      "Painless labour & birth-companion friendly delivery",
      "VBAC & high-risk pregnancy management",
      "Postnatal recovery & breastfeeding support",
    ],
  },
  {
    slug: "infertility-treatment",
    title: "Infertility & Reproductive Health",
    short: "Advanced fertility solutions and IVF treatments designed to help you achieve your dream of parenthood.",
    icon: "Sparkles",
    image: "/images/facilities/DSC09848.webp",
    bullets: ["IVF & fertility assessment", "Hormonal therapy", "Personalized treatment plans"],
    long: [
      "A diagnosis of infertility can feel isolating. Dr. Priyanka builds a treatment plan rooted in honest conversation, careful diagnostics and the least-invasive path that works for you.",
      "From ovulation tracking and IUI to advanced IVF coordination and laparoscopic correction of fertility blockers like fibroids and endometriosis — every couple is treated with the privacy and respect they deserve.",
    ],
    highlights: [
      "Couple fertility evaluation",
      "Ovulation induction & IUI",
      "PCOS & endometriosis management",
      "IVF / ICSI coordination",
      "Recurrent pregnancy loss workup",
    ],
  },
  {
    slug: "laparoscopy",
    title: "Advanced Laparoscopy",
    short: "Minimally invasive surgical procedures for faster recovery and better outcomes.",
    icon: "Stethoscope",
    image: "/images/facilities/DSC09794.webp",
    bullets: ["Diagnostic laparoscopy", "Endometriosis treatment", "Quick recovery time"],
    long: [
      "As a Fellow in Laparoscopic Surgery, Dr. Priyanka brings advanced minimally-invasive precision to gynaecological surgery — smaller incisions, less pain, shorter hospital stays.",
      "Procedures are performed in WellMed Hospitals' modular operation theatres, equipped with the latest laparoscopy systems for safe and efficient outcomes.",
    ],
    highlights: [
      "Diagnostic & operative laparoscopy",
      "Myomectomy (fibroid removal)",
      "Ovarian cyst & endometriosis surgery",
      "Hysteroscopy",
      "Total laparoscopic hysterectomy",
    ],
  },
  {
    slug: "general-gynecology",
    title: "General Gynecology",
    short: "Comprehensive care for women's health concerns across every stage of life.",
    icon: "HeartPulse",
    image: "/images/facilities/DSC04313.webp",
    bullets: ["Annual health screenings", "Menstrual disorders", "Preventive care"],
    long: [
      "Routine isn't ordinary. Annual screenings, pap smears, and proactive conversations about your cycle and reproductive health are the foundation of staying well — for years to come.",
      "Personalised care for menstrual irregularities, PCOD, hormonal disorders, infections, contraception and adolescent gynaecology — in a private, judgment-free space.",
    ],
    highlights: [
      "Pap smear & HPV screening",
      "PCOS / PCOD management",
      "Contraceptive counselling",
      "Adolescent gynaecology",
      "Pelvic pain & infections",
    ],
  },
  {
    slug: "womens-wellness",
    title: "Women's Wellness Programs",
    short: "Holistic wellness programs designed to support women through every stage of life.",
    icon: "Flower2",
    image: "/images/facilities/DSC04307.webp",
    bullets: ["Hormonal health programs", "Menopausal care", "Preventive health"],
    long: [
      "Wellness for women is a long arc — from adolescence through perimenopause and beyond. Dr. Priyanka curates structured wellness programs that bring together hormonal health, bone density, breast health, and lifestyle.",
      "Programs are tailored, never templated — combining clinical assessments with a deeply personal conversation about your goals.",
    ],
    highlights: [
      "Perimenopause & menopause care",
      "Hormone balance programs",
      "Bone & breast health screening",
      "Pre-conception counselling",
      "Lifestyle & nutrition guidance",
    ],
  },
  {
    slug: "emotional-support",
    title: "Emotional Support",
    short: "Beyond medical care, receive compassionate emotional guidance throughout your journey.",
    icon: "HandHeart",
    image: "/images/facilities/DSC04275.webp",
    bullets: ["Individual attention", "Empowering guidance", "Comfortable environment"],
    long: [
      "Healthcare for women is rarely just clinical. Anxiety, grief, postnatal blues, body changes — these are real, and they deserve attention.",
      "Every consultation is unhurried. You are listened to. When clinical psychology support is needed, you'll be referred to a trusted specialist within the WellMed network.",
    ],
    highlights: [
      "Pregnancy emotional well-being",
      "Postnatal mental health check-ins",
      "Grief support after pregnancy loss",
      "Body image & menopause counselling",
      "Family-inclusive consultations",
    ],
  },
];

export const testimonials = [
  {
    name: "Gaurav Dutt Sharma",
    text: "I recently had the wonderful experience of welcoming my first baby under the care of Dr. Priyanka Gupta. Her calm and reassuring approach made the entire journey smooth and stress-free. Highly recommend!",
  },
  {
    name: "Kritika Sharma",
    text: "I had a truly wonderful experience at Wellmed Hospital. Dr. Priyanka Gupta was incredibly calm, supportive, and professional. The complimentary casting service and photo shoot were such thoughtful touches!",
  },
  {
    name: "Pawan Choudhury",
    text: "Dr. Priyanka Gupta is very supportive and soft spoken. She always guides you in every aspect. Supporting staff very co-operative. Will recommend everyone to make your parental journey more comfortable.",
  },
  {
    name: "Kaushal Deva",
    text: "We're fortunate to have met Dr. Priyanka Gupta and her team. We received all the treatment and care we needed — along with some extra, forever-memorable moments like the baby's photos and footprints beautifully framed.",
  },
  {
    name: "Armaan Singhla",
    text: "We had an excellent experience with Dr. Priyanka Gupta. In just one consultation, she accurately diagnosed the issue. She is highly knowledgeable, kind and compassionate. Highly recommend!",
  },
  {
    name: "Pawan Jain",
    text: "Very nice experience with Dr. Priyanka Gupta in delivering our baby. Despite complications, she delivered through normal delivery. Her hospital 'Wellmed Hospital' is equipped with all necessary infrastructure.",
  },
  {
    name: "Neha Verma",
    text: "From the first consultation to delivery, Dr. Priyanka was deeply patient with all my questions. The team at WellMed felt like extended family. Genuinely recommend.",
  },
  {
    name: "Ritu Ahuja",
    text: "Suffered with fibroids for years. The laparoscopic surgery was smooth, and recovery was way faster than I expected. Thank you doctor for your reassurance.",
  },
];

export const faqs = [
  {
    q: "What conditions does Dr. Priyanka Gupta treat?",
    a: "Dr. Priyanka treats the full spectrum of obstetric and gynaecological conditions — including high-risk pregnancies, infertility, PCOS, endometriosis, fibroids, menstrual disorders, menopause, and preventive women's wellness.",
  },
  {
    q: "Where does Dr. Priyanka practice?",
    a: "Dr. Priyanka practices at WellMed Hospitals, 242, Sector 39, Gurugram, Haryana 122003 — the hospital she co-founded.",
  },
  {
    q: "What are the consultation hours?",
    a: "Morning consultations are 11:00 AM – 2:00 PM and evening consultations are 6:00 PM – 8:00 PM, Monday to Saturday. Sunday is closed except for emergencies.",
  },
  {
    q: "How do I book an appointment?",
    a: "You can book an appointment using the form on the Appointment page, by calling 072899 99292, or by sending a WhatsApp message — whichever feels most comfortable for you.",
  },
  {
    q: "Does Dr. Priyanka handle high-risk pregnancies?",
    a: "Yes. With 20+ years of experience and over 20,000 deliveries, Dr. Priyanka is widely recognised for her management of high-risk pregnancies — including diabetes, hypertension, recurrent pregnancy loss, twin pregnancies and more.",
  },
  {
    q: "Are laparoscopic surgeries available?",
    a: "Yes. As a Fellow in Laparoscopic Surgery, Dr. Priyanka performs advanced minimally-invasive procedures including myomectomy, ovarian cystectomy, hysterectomy, and endometriosis surgery in WellMed's modular OTs.",
  },
  {
    q: "Is WellMed Hospital NABH accredited?",
    a: "Yes. WellMed Hospitals is a 50-bed NABH-accredited multi-specialty hospital with a Cath Lab, modular OTs, ICU, NICU, modern labour room, and 24×7 emergency services.",
  },
  {
    q: "Do you offer fertility treatments and IVF coordination?",
    a: "Yes. Dr. Priyanka offers complete fertility evaluation, ovulation induction, IUI, and IVF / ICSI coordination — along with treatment for the underlying causes (PCOS, endometriosis, fibroids) where surgery is indicated.",
  },
  {
    q: "What languages does Dr. Priyanka speak?",
    a: "English and Hindi. Consultations are unhurried so you have time to share concerns in the language you're most comfortable in.",
  },
];

export const facilities = [
  { title: "Cath Lab", desc: "Advanced cardiac procedures with the latest Philips technology.", icon: "Activity" },
  { title: "Modular Operation Theatres", desc: "State-of-the-art surgical facilities with advanced laparoscopy sets.", icon: "Scissors" },
  { title: "ICU & NICU", desc: "Intensive care for adults and a fully equipped Neonatal ICU for newborns.", icon: "HeartPulse" },
  { title: "Modern Labour Room", desc: "Comfortable, well-equipped delivery rooms for safe, dignified birthing.", icon: "Baby" },
  { title: "24×7 Emergency", desc: "Round-the-clock emergency department, lab and diagnostic services.", icon: "Siren" },
  { title: "Diagnostic Imaging", desc: "On-site ultrasound, X-ray and pathology for swift, accurate care.", icon: "Microscope" },
];

export const credentials = [
  { label: "MBBS", detail: "Pt. Bhagwat Dayal Sharma PGIMS, Rohtak" },
  { label: "MD (Obstetrics & Gynaecology)", detail: "Gold Medalist — The MS University of Baroda" },
  { label: "Fellow in Laparoscopy", detail: "Advanced minimally invasive surgery" },
  { label: "Member", detail: "FOGSI / Indian Medical Association" },
];
